import { useMemo } from "react";
import { useProjectStore } from "../state/projectStore";
import { useKeyStore } from "../state/keyStore";
import { chordView, type ChordView, type KeySetting } from "../core/theory/transpose";

const NO_KEY = { tonic: "C", quality: "major" as const };
const ORIGINAL: KeySetting = { transpose: 0, capo: 0 };

/** how chords are drawn right now (key/capo applied). `original` = the song's own key, e.g. under the
 *  user's PDF sheet, which can't be transposed. */
export function useChordView(original = false): ChordView {
  const key = useProjectStore((s) => s.analysis?.key);
  const transpose = useKeyStore((s) => s.transpose);
  const capo = useKeyStore((s) => s.capo);
  return useMemo(
    () => chordView(key ? { tonic: key.tonic, quality: key.quality } : NO_KEY, original ? ORIGINAL : { transpose, capo }),
    [key, transpose, capo, original],
  );
}
